export default "__VITE_ASSET__BVEOlSrY__"